var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLove = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 79,
    viewBox: "0 0 140 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9641_930",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 140,
    height: 79
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 78.2609,
    rx: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9641_930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.983 81.1123C126.409 87.3894 150.488 73.4873 156.765 50.0611C163.042 26.635 149.14 2.55587 125.714 -3.72114C102.288 -9.99815 78.2085 3.90396 71.9315 27.3301C70.0328 34.4163 69.9805 41.5623 71.4796 48.2572",
    stroke: "#FFC61B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.568 36.1098L109.299 28.9609C110.54 27.0786 110.971 24.8319 110.514 22.6319C110.063 20.4306 108.778 18.5408 106.889 17.3091C105.001 16.0773 102.753 15.657 100.543 16.1166C98.3324 16.5761 96.4332 17.8654 95.1926 19.7477L94.5446 20.7307L93.5432 20.0774C93.1302 19.808 92.6993 19.577 92.2549 19.3851C91.7354 19.1609 91.1975 18.9904 90.6484 18.8749C89.5195 18.6377 88.3431 18.6334 87.1813 18.8749C84.9772 19.3332 83.078 20.6225 81.8424 22.4971C80.6017 24.3794 80.1702 26.6261 80.634 28.8247C81.0914 31.0247 82.3877 32.9056 84.2758 34.1373L98.6318 43.5025C98.8305 43.6322 99.0706 43.6743 99.2859 43.6296C99.5012 43.5848 99.7059 43.4568 99.8365 43.2586L101.019 41.4714",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.005 24.7339L121.006 24.7314C122.086 22.8479 123.84 21.5069 125.95 20.9467C128.051 20.3891 130.251 20.6813 132.139 21.7719C134.033 22.8653 135.389 24.6328 135.96 26.742L136.299 27.9955C136.443 28.5268 136.989 28.8421 137.521 28.7009L138.757 28.3729C140.867 27.8127 143.067 28.105 144.962 29.199C146.858 30.2936 148.207 32.043 148.777 34.15C149.347 36.2559 149.057 38.4416 147.965 40.3205L147.964 40.323C146.877 42.2049 145.123 43.5462 143.013 44.1064C143.013 44.1065 143.013 44.1066 143.012 44.1067L125.062 48.8352L120.213 30.9115C119.986 30.0699 119.893 29.2176 119.932 28.3792C119.991 27.1112 120.35 25.868 121.005 24.7339Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8262 54.7827C86.0871 52.6088 85.8997 49.6796 87.8263 50.4349C100 56.9566 119.329 60.3827 132.609 58.6958C138.307 57.972 119.499 83.3881 96.2419 67.6713",
    stroke: "#7F39FA",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9641_930)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 137.5,
    height: 75.7609,
    rx: 6.75,
    stroke: "#FFC61B",
    strokeWidth: 2.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9641_930",
    x: -11,
    y: -11,
    width: 162,
    height: 100.261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_9641_930"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.925 0 0 0 0 0.71256 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9641_930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9641_930",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/love.e01ad6e7a6ad8914ff35cd8186135cb6.svg";